import { Box, Tab, Tabs } from "@mui/material";
import { memo } from "react";
import PropTypes from "prop-types";

import { CRM_CARD_SX } from "./initialReviewStyles";

export const REQUEST_TAB_IDS = {
  INFO: "info",
  MEDIA: "media",
  CONVERSATIONS: "conversations",
  HISTORY: "history",
};

const DEFAULT_TAB_LABELS = [
  { id: REQUEST_TAB_IDS.INFO, label: "اطلاعات پرونده" },
  { id: REQUEST_TAB_IDS.MEDIA, label: "تصاویر و مدارک" },
  { id: REQUEST_TAB_IDS.CONVERSATIONS, label: "گفتگوها" },
  { id: REQUEST_TAB_IDS.HISTORY, label: "تاریخچه" },
];

const RequestTabs = memo(({ activeTab, onChange, children, tabs }) => {
  const tabLabels = Array.isArray(tabs) && tabs.length > 0 ? tabs : DEFAULT_TAB_LABELS;

  return (
    <Box>
      <Box sx={{ ...CRM_CARD_SX, mb: 0, px: { xs: 1, md: 2 } }}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => onChange(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 48,
            "& .MuiTab-root": {
              minHeight: 48,
              py: 1,
              fontSize: "0.9375rem",
              fontWeight: 600,
              lineHeight: 1.5,
            },
          }}
        >
          {tabLabels.map((tab) => (
            <Tab key={tab.id} value={tab.id} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Box>
  );
});

RequestTabs.displayName = "RequestTabs";

RequestTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default RequestTabs;
